import N2StylesModal from "../components/N2StylesModal";
import AssetUploader from "../components/uploads/AssetUploader";
import AutoSaveTextField from "../components/AutoSaveTextField";
import AutoSaveSelect from "../components/AutoSaveSelect";

import DigitalJobsAreaDirector from "./DigitalJobsAreaDirector";
import DigitalJobsDigitalDesigner from "./DigitalJobsDigitalDesigner";
import DigitalJobsDigitalCreativeDirector from "./DigitalJobsDigitalCreativeDirector";

export default class DigitalJobs {
  constructor(params) {
    this.params = params;
    this.role = params.role || null;
  }

  index() {
    /* eslint-disable no-else-return */
    if (this.hasRole("area_director")) {
      return new DigitalJobsAreaDirector().perform();
    } else if (this.hasRole("digital_designer")) {
      return new DigitalJobsDigitalDesigner().perform();
    } else if (this.hasRole("digital_creative_director")) {
      return new DigitalJobsDigitalCreativeDirector().perform();
    }
  }

  show() {
    if (this.role === "account_manager") {
      this.bindAdSuspensionModal();
      this.bindConfirmationModal();
    } else if (this.role === "digital_designer" || this.role === "digital_creative_director") {
      this.initAutoSaveTextFields();
      new AutoSaveSelect();
      $("#digital_job_alternate_website_url").on("keypress", (event) => {
        if (event.keyCode === 13) { // listening for "enter" key press
          event.preventDefault();
          $(event.target).trigger("blur");
        }
      });

    } else if (this.role === "area_director") {
      // this element only exists if the client has not given permission to post to Facebook
      new N2StylesModal(".js-missing-client-permission-modal");
      this.bindConfirmationModal();
    }
  }

  bindAdSuspensionModal() {
    N2.bindHandler("click", ".js-suspend-digital-ad", (evt) => {
      evt.preventDefault();
      new N2StylesModal(".js-suspend-digital-ad-modal");
    });
  }

  bindConfirmationModal() {
    const roleClass = this.role.replace("_", "-");
    N2.bindHandler("click", `.js-${roleClass}-confirmation-btn`, (evt) => {
      evt.preventDefault();
      new N2StylesModal(".js-digital-job-confirmation-modal");
    });
  }

  initAutoSaveTextFields() {
    new AutoSaveTextField(this, { attrName: "demo_url", klass: "digital_job", submitUrl: this.autoSaveTextFieldUrl() });
    new AutoSaveTextField(this, { attrName: "alternate_website_url", klass: "digital_job", submitUrl: this.alternateWebsiteTextFieldUrl() });
  }

  // Methods used by AssetUploader
  assetUploadImageLabel() {
    return "File";
  }

  assetUploadUrl() {
    return `/digital_jobs/${this.params.id}/assets/design_asset`;
  }

  autoSaveTextFieldUrl() {
    return `/digital_jobs/${this.params.id}/demo_url`;
  }

  alternateWebsiteTextFieldUrl() {
    return `/digital_jobs/${this.params.id}/alternate_website_url`;
  }

  makeImagePreview(src) {
    const image = $(`<img class="img-fluid w-100" src="${src}">`);

    return image;
  }

  runCallbacks() {
    this.updateCardFooter();
  }

  showImagePreview(src) {
    $("#js-preview-image").html(this.makeImagePreview(src));
  }

  updateCardFooter() {
    this.canFinish = $("#proof_asset").find("#proof_asset-filename").length > 0 &&
    $("#design_asset").find("#design_asset-filename").length > 0 &&
    $("#digital_job_demo_url")[0].value.length > 0;

    if (this.canFinish) {
      $("#js-transition-button").removeClass("hidden");
    } else {
      $("#js-transition-button").addClass("hidden");
    }
  }

  hasRole(role) {
    return this.role === role;
  }
}
